

















import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { navigationQueryName } from './utils';
import { Watch } from 'vue-property-decorator';
import { lightenColor } from '@/utils/color';

@Component({
  name: 'StatementClient',
})
export default class App extends Vue {

  @Getter('dataManagement/bgColor')
  private bgColor!: CSSStyleDeclaration['color'];

  @Getter('dataManagement/themeColor')
  private themeColor!: CSSStyleDeclaration['color'];

  public created(): void {
    this.initMessageListener();
  }

  public mounted(): void {
    this.initSnackBar();
  }

  @Watch('themeColor', {immediate: true})
  private setScrollbarColor(): void {
    const color = (this.themeColor.includes('#'))
      ? lightenColor(this.themeColor, 0.5)
      : this.themeColor;
    document.body.style.setProperty('--scrollbar-thumb-color', color);
  }

  private initSnackBar(): void {
    Vue.prototype.$snackbar = this.$refs.snackbar;
  }

  private initMessageListener(): void {
    window.onmessage = (e: MessageEvent) => {
      if (e.data[navigationQueryName]) {
        this.$store.commit('dataManagement/SET_IFRAME_URL_QUERY', e.data[navigationQueryName]);
      }
      if (e.data.button === true) {
        this.$store.commit('dataManagement/ENABLE_COPY_LINK_BUTTON', true);
      }
    };
  }

}
